import { useContext, useEffect, useState } from 'react';
import { ProductResultsContext } from '../ProductResultsContext';

export const useInStoreState = () => {
  const [changeStore, setChangeStore] = useState(false);
  const [isNearbyStores, setIsNearbyStores] = useState(true);
  const [storeSearch, setStoreSearch] = useState([]);
  const { data } = useContext(ProductResultsContext);
  const { stores } = data?.searchModel?.metadata || {};

  const {
    storeId,
    storeName,
    phone,
    address
  } = stores ?? {};

  const multiStoreSelection = stores?.nearByStores?.length
    ? [stores?.storeId, ...stores.nearByStores.map((store) => store.storeId)] : [];

  const onMultiStoreSelectionChange = ({ stores: multiStoreIds }) => {
    const storeSelection = [...multiStoreIds].filter((selectedStore) => selectedStore.checked).map(
      (selectedStore) => selectedStore?.storeId?.toString());
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('NEARBY_STORES.update', { nearByStores: storeSelection });
  };

  useEffect(() => {
    const updatedStoreSearch = [{
      storeId,
      storeName,
      phone,
      address
    }];
    if (!stores) {
      return;
    }
    const allStores = [...updatedStoreSearch, ...(stores?.nearByStores || [])];
    setStoreSearch(allStores);
  }, [stores]);

  const toggleChangeStore = () => {
    setChangeStore(!changeStore);
  };

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NEARBY_STORES.update', ({ output }) => {
      const { nearByStores } = output;
      setIsNearbyStores(nearByStores?.length > 1);
    });
  }, []);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('NEARBY_STORES.update',
      { nearByStores: isNearbyStores ? multiStoreSelection : [storeId] });
  }, [isNearbyStores]);

  return {
    changeStore,
    isNearbyStores,
    storeSearch,
    toggleChangeStore,
    setIsNearbyStores,
    storeName,
    address,
    multiStoreSelection,
    onMultiStoreSelectionChange
  };
};